import { jsxs as m, jsx as e } from "react/jsx-runtime";
import r from "./styles.module.less.js";
import s from "./profile-no-img.svg.js";
const l = (a) => {
  const { userImage: t, hasNotifications: i } = a;
  return /* @__PURE__ */ m("div", { className: r.userImageContainer, children: [
    /* @__PURE__ */ e(
      "img",
      {
        src: t ?? s,
        onError: (o) => {
          o.currentTarget.src = s;
        },
        alt: "user",
        className: r.userImage,
        width: 24,
        height: 24
      }
    ),
    i && /* @__PURE__ */ e("div", { className: r.notificationBadge })
  ] });
};
export {
  l as UserImage
};
